
	import { Component, Vue } from 'vue-property-decorator';
	import TimeoutError from '@/components/TimeoutError.vue';
	import SnackbarBottom from '@/components/SnackbarBottom.vue';
	import Updater from '@/components/Updater.vue';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: { TimeoutError, SnackbarBottom, Updater }
	})
	export default class Index extends Vue {
		async mounted() {
			setTimeout(() => {
				if (!this.$state.agent.updateAvailable) {
					this.$state.agent.requiredUpdate = false;
				}
			}, 5000);
		}

		patients() {
			this.$router.push('patients');
		}

		newSession() {
			this.$state._patient.clear();
			this.$router.push('getting-started');
		}
	}
